import { render, staticRenderFns } from "./CenterPanel.vue?vue&type=template&id=c2f52a40&scoped=true"
import script from "./CenterPanel.vue?vue&type=script&lang=js"
export * from "./CenterPanel.vue?vue&type=script&lang=js"
import style0 from "./CenterPanel.vue?vue&type=style&index=0&id=c2f52a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f52a40",
  null
  
)

export default component.exports